(() => {
  function pushEvent(event, details = {}) {
    const allowed = window.AlphaPCLeadAttribution?.trackingAllowed?.()
      ?? (
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true
      )
      ?? false;
    if (!allowed) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...details });
  }

  function initializeHub(hub) {
    if (!hub || hub.dataset.metroHubReady === 'true') return;
    hub.dataset.metroHubReady = 'true';

    const filterGroup = hub.querySelector('[data-metro-hub-filter-group]');
    const cards = Array.from(hub.querySelectorAll('[data-metro-market-card]'));
    if (!filterGroup || !cards.length) return;

    const buttons = Array.from(filterGroup.querySelectorAll('[data-metro-cluster]'));
    const status = filterGroup.querySelector('[data-metro-filter-status]');
    const pluralTemplate = filterGroup.dataset.resultPlural || '[count] markets shown';
    const singularText = filterGroup.dataset.resultSingular || '1 market shown';

    const updateStatus = (count) => {
      if (!status) return;
      status.textContent = count === 1
        ? singularText
        : pluralTemplate.replace('[count]', String(count));
    };

    const applyFilter = (cluster) => {
      let visible = 0;
      cards.forEach((card) => {
        const clusters = (card.dataset.clusters || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
        const matches = cluster === 'all' || clusters.includes(cluster);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.metroCluster === cluster));
      });
      updateStatus(visible);
      return visible;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const cluster = button.dataset.metroCluster || 'all';
        const visible = applyFilter(cluster);
        pushEvent('enterprise_market_filter', {
          workload_cluster: cluster,
          markets_shown: visible,
          page_path: window.location.pathname
        });
      });
    });
    applyFilter('all');
  }

  function initialize(root = document) {
    const hubs = root.matches?.('[data-metro-hub]')
      ? [root]
      : Array.from(root.querySelectorAll?.('[data-metro-hub]') || []);
    hubs.forEach(initializeHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
